import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsRegions from "../generic-nav-bar/NavbarIconsRegions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { regionStartRegister } from "../../app/actions/catalogRegionActions";
import { schemaValidateRegionsList } from "../../app/data/schemaValidateRegionsList";
import { debugLogPages } from "../../app/helpers/debugHelper";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import EditYearGeneric from "../generic-component/EditYearGeneric";
import NewCatalogRelationGeneric from "../generic-component/NewCatalogRelationGeneric";
import NewDateGeneric from "../generic-component/NewDateGeneric";
import NewInputGeneric from "../generic-component/NewInputGeneric";
import NewRelationGeneric from "../generic-component/NewRelationGeneric";
import NewTextGeneric from "../generic-component/NewTextGeneric";
import ViewLabel from "../generic-component/ViewLabel";
import NewCatalogLocationGenericForAdmin from "../generic-component/NewCatalogLocationGenericForAdmin";

const ID_FORM = "admin-region";
const OPERATION = "register";

const NewRegions = () => {
  debugLogPages(':: NewRegions');
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { catalogRegion } = useSelector((state) => state.catalogRegion);

  const { catalogContinents } = useSelector((state) => state.catalogContinent);

  const { t } = useTranslation();

  const { values, errors, handleChange, handleSubmit, handleChangeCatalogCiiu,
    handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeLocationForAdmin } = useFormValidationsGeneric(
      () => regionCallback(),
      catalogRegion,
      schemaValidateRegionsList
    );

  useEffect(() => {

    if (values) {
      handleChange(getObjectById(values.continent_id, catalogContinents), "continent_id");

    }

  }, [catalogContinents])

  const getObjectById = (id, arraySearch) => {
    const elementFound = arraySearch.find((ser) => ser.id === id);
    return elementFound;
  };

  const getMethodData = (currentData) => {
    let comboData = [];
    let level = 0;

    if (currentData === "continent_id") {
      comboData = catalogContinents;
      level = 1;
    }

    return { comboData, level };
  };

  const regionCallback = () => {
    debugLogPages(':: NewRegions, regionCallback, values', {values});

    let valuesSubmit = { ...values };

    valuesSubmit.deleted = false;
    //valuesSubmit.continent_id = valuesSubmit.continent_id.id;

    debugLogPages(':: NewRegions, regionCallback, valuesSubmit', {valuesSubmit});
    dispatch(regionStartRegister(valuesSubmit, navigate));
  
  };

  debugLogPages(':: NewRegions', { 'values': values });
  debugLogPages(':: NewRegions', { 'errors': errors });

  return (
    <div>
      <NavbarIconsRegions page={"newRegions"} />
      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>

            {/* Formulario dinamico*/}

            <div className="row boxContent">
              {
                schemaValidateRegionsList && schemaValidateRegionsList.length > 0 && (
                  schemaValidateRegionsList.map((techSecondary, index) => {

                    let varField = techSecondary.field;
                    let varRelation = techSecondary.key_relation;
                    const { comboData } = getMethodData(techSecondary.field);

                    if (techSecondary.component_new === "ViewGroupLabel") {
                      return (
                        <ViewLabel
                          key={techSecondary.id}
                          values={values}
                          errors={errors}
                          values2={varRelation}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_view}
                        />
                      )
                    } if (techSecondary.component_new === "NewInputGeneric") {
                      return (
                        <NewInputGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewRelationGeneric") {
                      return (
                        <NewRelationGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          comboData={comboData}
                        />
                      );
                    } else if (techSecondary.component_new === "NewTextGeneric") {
                      return (
                        <NewTextGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewYearGeneric") {

                      return (
                        <EditYearGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewDateGeneric") {
                      return (
                        <NewDateGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGeneric") {
                      if (techSecondary.comparable_relation_condition === "CatalogCiius") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogCiiu}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogSections") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogSection}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogPhases") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogPhase}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      }
                    } else if (techSecondary.component_new === "NewCatalogLocationGenericForAdmin") {
                      return (
                        <NewCatalogLocationGenericForAdmin
                          key={techSecondary.id}
                          handleChange={handleChangeLocationForAdmin}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                          comboData={comboData}
                        />
                      );
                    } else {
                      return (
                        <div>
                        </div>
                      )
                    }
                  })
                )
              }
            </div>

            {/* Fin Formulario dinamico */}

            <div className="btnGuardar">
              <input type="submit" value={t("buttons.submit")} className="btn btn-primary" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewRegions;
